"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../form/utils");

var _utils2 = require("../../utils");

var _constants = require("./constants");

var _dateTimeSegments = require("./date-time-segments");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TimePicker = function TimePicker(_ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? _constants.defaultTimeAriaLabels : _ref$ariaLabels,
      handleChange = _ref.handleChange,
      _ref$selectedTime = _ref.selectedTime,
      selectedTime = _ref$selectedTime === void 0 ? {} : _ref$selectedTime,
      showMilliseconds = _ref.showMilliseconds,
      showSeconds = _ref.showSeconds,
      showPeriod = _ref.showPeriod;
  var labelId = (0, _react.useMemo)(function () {
    return (0, _utils.buildLabelId)("StencilTimePicker-".concat((0, _utils2.getUniqueId)()));
  }, []);
  return (0, _core.jsx)(_helperComponents.TimeSegmentRow, null, (0, _core.jsx)(_dateTimeSegments.DateTimeSegments, {
    ariaLabels: ariaLabels,
    labelId: labelId,
    onChange: handleChange,
    segmentValues: selectedTime,
    showDate: false,
    showMilliseconds: showMilliseconds,
    showSeconds: showSeconds,
    showPeriod: showPeriod,
    showSpinButtons: true,
    showTime: true
  }));
};

var _default = TimePicker;
exports.default = _default;